import { render } from "./Meaning.vue?vue&type=template&id=28702bc3&scoped=true"
import script from "./Meaning.vue?vue&type=script&lang=js"
export * from "./Meaning.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28702bc3"]])

export default __exports__